"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _pickReactKnownProp = require("pick-react-known-prop");

var _ProductPriceElementDiscounPercent = _interopRequireDefault(require("@sprinx/react-com/ProductPriceElementDiscounPercent"));

var _ProductPriceElementPriceCvo = _interopRequireDefault(require("../../../components/ProductPriceElementPriceCvo/ProductPriceElementPriceCvo"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%'
    },
    labelStart: {
      marginRight: 0,
      marginLeft: theme.spacing(1.5)
    },
    labelEnd: {
      marginLeft: 0
    },
    percent: {
      marginRight: theme.spacing(2.5)
    },
    addToCartContainer: {
      display: 'flex',
      marginTop: theme.spacing(2),
      height: 47
    },
    container: {
      display: 'flex'
    },
    promoCodeContainer: {
      backgroundColor: '#eebc12',
      borderRadius: 6,
      width: '100%',
      display: 'grid',
      alignItems: 'center',
      justifyItems: 'center',
      gridTemplateColumns: 'repeat(3, auto)'
    },
    promoCodePrice: {
      fontSize: 25
    },
    promoCodeSubHeading: {
      fontSize: 16,
      marginBottom: theme.spacing(0.5)
    },
    promoCodeSubText: {
      fontSize: 18,
      marginTop: theme.spacing(0.5),
      fontWeight: 'bold'
    }
  };
}, {
  name: 'ProductPriceMobile'
});

function ProductPriceMobile(_ref) {
  var available = _ref.available,
      pClasses = _ref.classes,
      className = _ref.className,
      cur = _ref.currency,
      discountPercent = _ref.discountPercent,
      price = _ref.price,
      priceIsRelevant = _ref.priceIsRelevant,
      priceOriginalWithTax = _ref.priceOriginalWithTax,
      priceWithTax = _ref.priceWithTax,
      promoCode = _ref.promoCode,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["available", "classes", "className", "currency", "discountPercent", "price", "priceIsRelevant", "priceOriginalWithTax", "priceWithTax", "promoCode"]);
  var classes = useStyles({
    classes: pClasses
  });
  var t = (0, _useTranslate.default)();
  return priceIsRelevant ? /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
    className: (0, _clsx.default)(classes.root, className)
  }), promoCode.visualisation && promoCode.name && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.promoCodeContainer,
    style: {
      backgroundColor: promoCode.backgroundColor
    }
  }, /*#__PURE__*/_react.default.createElement(_ProductPriceElementPriceCvo.default, {
    currency: cur,
    value: promoCode.name ? Math.floor(priceWithTax - priceWithTax * promoCode.value) : null,
    size: "medium",
    color: available ? 'primary' : 'textSecondary',
    className: classes.promoCodePrice
  }), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.promoCodeSubHeading
  }, t('productDetail/promoCode/title')), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.promoCodeSubText
  }, promoCode.name)), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.promoCodeSubHeading
  }, t('productDetail/promoCode/validTo')), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.promoCodeSubText
  }, new Date(promoCode.validTo).toLocaleDateString(promoCode.locale)))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/_react.default.createElement(_ProductPriceElementPriceCvo.default, {
    currency: cur,
    value: priceOriginalWithTax,
    decoration: "strike",
    size: "small",
    color: available ? 'textPrimary' : 'textSecondary'
  }), /*#__PURE__*/_react.default.createElement(_ProductPriceElementDiscounPercent.default, {
    classes: {
      labelStart: classes.labelStart,
      labelEnd: classes.labelEnd,
      root: classes.percent
    },
    value: available ? discountPercent : undefined,
    labelStart: "(",
    labelEnd: ")",
    size: "small",
    currency: cur,
    color: available ? 'primary' : 'textSecondary'
  })), /*#__PURE__*/_react.default.createElement(_ProductPriceElementPriceCvo.default, {
    currency: cur,
    value: priceWithTax,
    size: "large",
    color: available ? 'primary' : 'textSecondary'
  }), /*#__PURE__*/_react.default.createElement(_ProductPriceElementPriceCvo.default, {
    currency: cur,
    value: price,
    size: "small",
    color: "textSecondary",
    labelStart: t('productPrice/withoutTax')
  })) : null;
}

process.env.NODE_ENV !== "production" ? ProductPriceMobile.propTypes = {
  available: _propTypes.default.bool,
  classes: _propTypes.default.shape({
    container: _propTypes.default.string,
    labelEnd: _propTypes.default.string,
    labelStart: _propTypes.default.string,
    percent: _propTypes.default.string,
    promoCodeContainer: _propTypes.default.string,
    promoCodePrice: _propTypes.default.string,
    promoCodeSubHeading: _propTypes.default.string,
    promoCodeSubText: _propTypes.default.string,
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  currency: _propTypes.default.string,
  discountPercent: _propTypes.default.number,
  price: _propTypes.default.number,
  priceIsRelevant: _propTypes.default.bool,
  priceOriginalWithTax: _propTypes.default.number,
  priceWithTax: _propTypes.default.number,
  product: _propTypes.default.shape({}).isRequired,
  promoCode: _propTypes.default.shape({
    backgroundColor: _propTypes.default.string,
    locale: _propTypes.default.string,
    name: _propTypes.default.string,
    validTo: _propTypes.default.string,
    value: _propTypes.default.number,
    visualisation: _propTypes.default.bool
  })
} : void 0;
ProductPriceMobile.defaultProps = {
  available: false,
  classes: undefined,
  className: undefined,
  currency: undefined,
  discountPercent: undefined,
  price: undefined,
  priceIsRelevant: undefined,
  priceOriginalWithTax: undefined,
  priceWithTax: undefined
};
var _default = ProductPriceMobile;
exports.default = _default;